module.exports = __webpack_public_path__ + "img/logo_bitda.05f20e28.png";